import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact() {
  const form = useRef<HTMLFormElement>(null!);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_ylpevus',
        'template_vfboicm',
        form.current,
        'YgGYlLlfcHHGtVf3N'
      )
      .then((result) => {
        console.log(result.text);
        form.current?.reset();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div
      id="contact"
      className="bg-whitish min-h-[93vh] md:py-16 md:px-12 p-5 dark:bg-greenish w-full flex md:flex-row flex-col justify-around items-center"
    >
      <div className=" text-greenish dark:text-beige  text-center my-3">
        <p className="text-3xl font-semibold">Let's Get In Touch!</p>
        <p className="text-xl dark:text-whitish text-night">
          Send an instant email
          <br />
          Or
          <br />
          Email at
          <br />
          <p className="underline">sarahaboudalal@gmail.com</p>
        </p>
      </div>
      <form
        ref={form}
        onSubmit={sendEmail}
        className="flex flex-col justify-center md:w-2/4 w-full"
      >
        <label className="my-3">
          <span className="text-2xl text-night dark:text-whitish">Name</span>
        </label>
        <input
          type="text"
          name="name"
          required
          placeholder="Name..."
          className="bg-beige text-night placeholder:text-greenish rounded-md border border-emerald-900 p-2 min-w-2/4"
        />
        <label className="my-3">
          <span className="text-2xl text-night dark:text-whitish">Email</span>
        </label>
        <input
          type="email"
          name="email"
          required
          placeholder="Email..."
          className="bg-beige text-night placeholder:text-greenish rounded-md border border-emerald-900 p-2 min-w-2/4"
        />
        <label className="my-3">
          <span className="text-2xl dark:text-whitish text-night">Message</span>
        </label>
        <textarea
          name="message"
          placeholder="Message..."
          required
          className="bg-beige text-night placeholder:text-greenish rounded-md border border-emerald-900 p-2 h-44 min-w-2/4"
        />
        <input
          className="bg-beige rounded-md cursor-pointer duration-100 p-2 text-greenish my-3 hover:bg-greenish hover:text-beige border border-emerald-900 hover:border-beige"
          type="submit"
          value="Send"
        />
      </form>
    </div>
  );
}
